import React, { useState, useEffect } from 'react'

const achievements = [
  { year: 2022, text: I18n.t('about_us.achievement.german'), icon: "flag-icon flag-icon-de" },
  { year: 2023, text: I18n.t('about_us.achievement.shop'), icon: "fas fa-shopping-cart" },
  { year: 2024, text: I18n.t('about_us.achievement.italian'), icon: "flag-icon flag-icon-it" },
]

const Achievements = () => {
  const [currentAchievementIndex, setCurrentAchievementIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentAchievementIndex((prevIndex) => {
        const nextIndex = prevIndex + 1
        if (nextIndex < achievements.length) {
          return nextIndex
        } else {
          clearInterval(timer)
          return prevIndex
        }
      })
    }, 750)

    return () => clearInterval(timer)
  }, [])

  return (
    <div className="achievement-list">
      {achievements.slice(0, currentAchievementIndex + 1).map((achievement, index) => (
          <div key={index} className="achievement d-flex align-items-center">
            <span className="text-dark h2">
              {achievement.year}
            </span>
            <span className="achievement-text">
              {achievement.text}
              <i className={`${achievement.icon} ms-2`}></i>
            </span>
          </div>
        ))}
    </div>
  )
}

export default Achievements
